<template>
    <v-tooltip top color="primary" open-delay="250">
        <template v-slot:activator="{ on }">
            <div v-on="on" class="display-1 text-center" v-if="project.completed_percent < 3">
                {{ roundValue(project.completed_percent, 1) }}<span class="text-h5">%</span>
            </div>
            <div v-else v-on="on" class="display-1 text-center">
                {{ Math.round(project.completed_percent) }}<span class="text-h5">%</span>
            </div>
        </template>
        <div>
            Completes: {{ project.completed_count }}
            <br>
            Target completes: {{ project.target_completes }}
        </div>

    </v-tooltip>
</template>

<script>

import {numberDisplay} from '../../../components/mixins/numberDisplayMixin';

export default {

    mixins: [numberDisplay],

    props: {
        project: {
            type: Object,
            required: true
        },
    },
}
</script>
